import { render, staticRenderFns } from "./link-icon.vue?vue&type=template&id=1f33d7a7&"
import script from "./link-icon.vue?vue&type=script&lang=js&"
export * from "./link-icon.vue?vue&type=script&lang=js&"
import style0 from "./link-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports